import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import useIsClient from '../../hooks/use-is-client';
import useStorage from '../../hooks/use-storage';
import Storage from '../../services/storage';
import DateUtils from '../../utils/date/DateUtils';
import MessageDisplayBanner from './components/MessageDisplayBanner';
import MessageDisplayModal from './components/MessageDisplayModal';
import './MessageDisplay.css';
var MODAL_KEY = 'showFishermanBannerMessage';
export default function MessageDisplay(_ref) {
  var modalDelay = _ref.modalDelay,
      disableCache = _ref.disableCache,
      businessName = _ref.businessName,
      subject = _ref.subject,
      content = _ref.content,
      bannerBackgroundColor = _ref.bannerBackgroundColor,
      modalExtra = _ref.modalExtra,
      modalButtonText = _ref.modalButtonText,
      disableModalButton = _ref.disableModalButton,
      startTime = _ref.startTime,
      endTime = _ref.endTime,
      timezone = _ref.timezone;

  var _useIsClient = useIsClient(),
      isClient = _useIsClient.isClient;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showBanner = _useState4[0],
      setShowBanner = _useState4[1];

  var _useStorage = useStorage(MODAL_KEY, false, {
    storageMechanism: Storage.SESSION_STORAGE
  }),
      _useStorage2 = _slicedToArray(_useStorage, 3),
      modalShownInSession = _useStorage2[0],
      setModalShownInSession = _useStorage2[1],
      storageLoaded = _useStorage2[2];

  function toggleModal() {
    setShowModal(function (previousShowModal) {
      if (previousShowModal && !disableCache) {
        // If we are showing the modal, make sure we don't show it again in the same session
        setModalShownInSession(true);
      }

      return !previousShowModal;
    });
  }

  useEffect(function () {
    if (modalDelay !== false && (!modalShownInSession || disableCache) && storageLoaded) {
      setTimeout(toggleModal, modalDelay);
    }
  }, [storageLoaded]);

  if (!isClient || !DateUtils.isNowBetweenDates(startTime, endTime, timezone)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "fm-message-display-container"
  }, showBanner && /*#__PURE__*/React.createElement(MessageDisplayBanner, {
    subject: subject,
    onClick: toggleModal,
    onClose: function onClose() {
      setShowBanner(false);
    },
    backgroundColor: bannerBackgroundColor,
    buttonText: modalButtonText,
    disableButton: disableModalButton
  }), /*#__PURE__*/React.createElement(MessageDisplayModal, {
    businessName: businessName,
    open: showModal,
    subject: subject,
    content: content,
    onClose: toggleModal,
    extra: modalExtra
  }));
}
MessageDisplay.defaultProps = {
  modalDelay: false,
  bannerBackgroundColor: '',
  modalButtonText: 'See More',
  modalExtra: /*#__PURE__*/React.createElement("div", null),
  disableCache: false,
  disableModalButton: false,
  startTime: null,
  endTime: null,
  timezone: null
};